import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { InputFormField, SelectFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper } from "@components";
import { selectAvailableCountryOptions } from "@redux";

export const ClientFundSentCountry = ({ control, countryIndex }) => {
  const availableCountries = useSelector(selectAvailableCountryOptions);
  return (
    <>
      {/* neccessary for form value */}
      <InputFormField
        control={control}
        name={`clientFundsSentCountry.${countryIndex}.clientFundsSentCountryType`}
        defaultValue={`CFUSC${countryIndex + 1}`}
        className="d-none"
      />

      <FullWidthInputWrapper>
        <SelectFormField
          control={control}
          name={`clientFundsSentCountry.${countryIndex}.data.clientFundsSentCountry`}
          title={trb(i18.Labels.ClientFundsSentCountry)}
          options={availableCountries}
          optionsLabel="label"
          optionsValue="value"
          isSearchable
          defaultValue="LT"
        />
      </FullWidthInputWrapper>
    </>
  );
};
